import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import FloatingLeafButton from "./FloatingLeafButton";
import { trackAction } from "../utils/umami";
import { AppIcon } from "../utils/appIcons";

const NavLink = ({ to, icon, label, event, setMenuOpen, className = "" }) => (
  <Link
    to={to}
    onClick={() => {
      trackAction(event);
      setMenuOpen(false);
    }}
    className={`flex items-center justify-center gap-3 px-4 py-2.5 rounded-xl hover:bg-white/50 transition ${className}`}
  >
    <AppIcon name={icon} size={20} />
    <span>{label}</span>
  </Link>
);

export const MobileNav = ({ menuOpen, setMenuOpen }) => {
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    if (menuOpen) {
      setAnimate(true);
      const timeout = setTimeout(() => {
        setAnimate(false);
      }, 4500); // stop after ~6 seconds
      return () => clearTimeout(timeout);
    }
  }, [menuOpen]);

  const handleOverlayClick = () => {
    trackAction("Leaf Button - Clicked to Close");
    setMenuOpen(false);
  };

  return (
    <>
      <FloatingLeafButton
        onClick={() => {
          trackAction("Leaf Button - Menu Clicked");
          setMenuOpen((prev) => !prev);
        }}
      />

      {/* Dark overlay */}
      {menuOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-30 z-40 " // backdrop-blur-sm
          onClick={handleOverlayClick}
        />
      )}

      {/* Bottom sheet menu */}
      <div
        className={`fixed bottom-0 left-0 w-full bg-white rounded-t-3xl shadow-2xl 
        transition-transform duration-300 ease-in-out z-50 
        bg-gradient-to-br from-[#f0ede7] via-[#e8e4de] to-[#f7f4ef] ${menuOpen ? "translate-y-0" : "translate-y-full"
          }`}
      >
        <div className="p-6">
          <div className="flex justify-end">
            <button
              onClick={() => {
                trackAction("Nav - Menu Closed");
                setMenuOpen(false);
              }}
              className="text-xl text-[#7c766f]"
            >
              ✕
            </button>
          </div>
          <nav className="mt-2 flex flex-col space-y-0.5 text-[1.05rem] text-[#5e5a55] font-medium">
            <NavLink to="/" icon="home" label="Home" event="Nav - Home Clicked" setMenuOpen={setMenuOpen} />
            <NavLink to="/storybook" icon="book" label="My Book" event="Nav - My Book Clicked" setMenuOpen={setMenuOpen} />
            <NavLink to="/latest-breaths" icon="breaths" label="Latest Breaths" event="Nav - Breaths Clicked" setMenuOpen={setMenuOpen} />
            <hr className="border-t border-black opacity-10 my-3" />
            <NavLink to="/reflect" icon="reflect" label="Reflect" event="Nav - Reflect Clicked" setMenuOpen={setMenuOpen} className={animate ? "animate-bounce" : ""} />
            <NavLink to="/connect" icon="connect" label="Connect" event="Nav - Connect Clicked" setMenuOpen={setMenuOpen} />
            <NavLink to="/saveanote" icon="note" label="Save a Note" event="Nav - Save a Note Clicked" setMenuOpen={setMenuOpen} />
            <hr className="border-t border-black opacity-10 my-3" />
            <NavLink to="/heart" icon="author" label="About the Author" event="Nav - About Author Clicked" setMenuOpen={setMenuOpen} />
            <NavLink to="/her-echoes" icon="echoes" label="Her Echoes" event="Nav - Her Echoes Clicked" setMenuOpen={setMenuOpen} />
          </nav>

          <div className="mt-auto pt-10 text-sm text-[#a39f97] text-center">
            {/* Made with ☁️ by Breathe */}
            <Link
              to="/heart"
              onClick={() => {
                trackAction("Nav - The Open Thread Clicked");
                setMenuOpen(false);
              }}
            // className="underline"
            // className="italic text-[#7c766f] hover:text-[#3c3a37] transition"
            >
              <span className="inline-flex items-center gap-1.5 justify-center">
                Made with <Heart size={13} color="#9c5a6a" fill="#9c5a6a" aria-hidden="true" /> by
                <span className="underline">The Open Thread</span>
              </span>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};


// export const DesktopNav = () => (
//   <div
//     // className="hidden md:flex justify-center gap-10 text-[#5e5a55]
//     // absolute top-6 left-1/2
//     // transform -translate-x-1/2 z-20 text-sm font-medium"
//     className="flex items-center justify-center gap-10 text-[#5e5a55]
//     text-sm font-medium mt-6"
//   >
//     {/* <div className="hidden md:flex fixed gap-10 top-0 left-1/2 transform -translate-x-1/2 z-40 bg-[#f8f5f0]/70 backdrop-blur-md px-6 py-3 rounded-b-xl shadow-md"> */}{" "}
//     <Link to="/" className="hover:text-[#3c3a37] transition">
//       Home
//     </Link>
//     <Link to="/reflect" className="hover:text-[#3c3a37] transition">
//       Reflect
//     </Link>
//     <Link to="/archive" className="hover:text-[#3c3a37] transition">
//       Archive
//     </Link>
//     <Link to="/connect" className="hover:text-[#3c3a37] transition">
//       Connect
//     </Link>
//   </div>
// );
